import * as ENV from './env';
import rollbar  from '../rollbar';

let lazyVersion;

export default async function getAppBuildAndVersion() {
  if (lazyVersion)
    return lazyVersion;

  if (ENV.isCordova() && window.cordova.getAppVersion) {
    try {
      const { getAppVersion } = window.cordova;
      const version           = await getAppVersion.getVersionNumber();
      const build             = await getAppVersion.getVersionCode();
      return { version, build };
    } catch (error) {
      // to not block requests if some error happens
      rollbar.error(error);
    }
  }

  return { version: null, build: null };
}
